// extracted by mini-css-extract-plugin
export default {"gameOver":"style_gameOver__mvZie","glitch-p":"style_glitch-p__l4el0","glitch-b":"style_glitch-b__hTd7P","glitch-a":"style_glitch-a__DYu8u"};